import { useEffect, useState } from "react";
import "../../index.css";
import { useTranslationHook } from "../hooks/useTranslationHook";
import CryptoListTileCard from "./CryptoListTileCard";
import SectionTitle from "./SectionTitle";
import { THEME_COLORS } from "../themes/DarkLight";
import useThemeHook from "../hooks/useThemeHook";
import { FONTSIZE, imagesUrls } from "../../constants";
import { useNavigate } from "react-router-dom";
import { PAGE_NAME } from "../../types";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../redux";

const AllCryptos = ({ row = false }: { row?: boolean }) => {
  const [isLoading, setIsLoading] = useState(false);
  const cryptos = useSelector((state: any) => state?.supportedCryptos);
  const userData = useSelector((state: any) => state?.actualUser);
  const piPrice = useSelector((state: any) => state?.piPrice);
  const dispatch = useDispatch();
  const featuredCryptos = [
    {
      image: imagesUrls["arthereum"],
      price_change_percentage_24h: 0,
      current_price: 0,
      name: "Arthereum",
      balance: 0,
    },
    {
      image: imagesUrls["pi"],
      price_change_percentage_24h: 0,
      current_price: piPrice,
      name: "PiCoin",
      balance: userData?.user?.picoinBalance ?? 0,
    },
  ];

  const handleCryptoClick = (crypto: any) => {
    console.log("Clicked crypto:", crypto);
  };

  const cryptoData = [...featuredCryptos, ...cryptos]
    .slice(0, row ? undefined : 5)
    .map((crypto, index) =>
      row ? (
        <div
          key={index}
          onClick={() => handleCryptoClick(crypto)}
          className="flex flex-col items-center justify-center gap-2 cursor-pointer"
          style={{
            paddingLeft: index === 0 ? "15px" : "0px",
            marginRight: "6px",
          }}
        >
          <img
            loading="lazy"
            src={crypto["image"] || "/placeholder.svg"}
            alt={crypto?.name}
            className={`h-16 w-16 object-cover rounded-full border-4 ${
              crypto["price_change_percentage_24h"] < 0
                ? "border-red-500"
                : "border-green-500"
            }`}
          />
          <p
            className={`text-xs font-medium ${
              crypto["price_change_percentage_24h"] < 0
                ? "text-red-600"
                : "text-green-600"
            }`}
          >
            {(crypto["current_price"] as any)?.toFixed(2)}
          </p>
        </div>
      ) : (
        <CryptoListTileCard
          key={index}
          crypto={crypto}
        />
      )
    );

  useEffect(() => {
    // getTop100Cryptocurrencies();
  }, []);

  const theme = useThemeHook();
  const navigate = useNavigate();
  const goToCryptoView = (crypto: any) => {
    navigate(PAGE_NAME.CRYPTO_VIEW_PAGE, { state: { crypto } });
  };

  const getTranslationText = useTranslationHook();

  return (
    <>
      {isLoading && row && (
        <div className="w-full flex items-center justify-center p-4">
          <div className="animate-spin h-8 w-8 border-4 border-gray-300 border-t-blue-600 rounded-full" />
        </div>
      )}
      <div
        className={`w-full flex items-start justify-start ${
          row
            ? "flex-row overflow-x-scroll"
            : "flex-col pt-5 pb-1"
        } hide-scrollbar`}
      >
        {!row && (
          <div className="flex flex-row gap-2 items-center justify-between mb-1 px-2.5 w-full">
            <SectionTitle text={getTranslationText("supported_cryptos")} />
          </div>
        )}
        {isLoading && !row && (
          <div className="w-full flex items-center justify-center p-4">
            <div className="animate-spin h-8 w-8 border-4 border-gray-300 border-t-blue-600 rounded-full" />
          </div>
        )}
        {!isLoading && cryptoData}
      </div>
    </>
  );
};

export default AllCryptos;
